import { createFileRoute } from "@tanstack/react-router"

import { RollenPage } from "@/components/admin/auswertung/rollen-page"

export const Route = createFileRoute("/_app/admin/rollen")({
  component: RollenPage,
})
